import { render, staticRenderFns } from "./StudyDetail.vue?vue&type=template&id=f1cb1ecc&"
import script from "./StudyDetail.vue?vue&type=script&lang=js&"
export * from "./StudyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports